'use client';

import { BackToTopButton, ScrollProgress, useScrollProgress } from 'src/components/animate';
import { SupportMain } from '../support-main';
import { useLocale } from 'src/locales';

export function SupportView() {
  const pageProgress = useScrollProgress();
  const { t } = useLocale();
  return (
    <>
      <ScrollProgress
        variant="linear"
        progress={pageProgress.scrollYProgress}
        sx={{ position: 'fixed' }}
      />
      <BackToTopButton />
      <SupportMain />
    </>
  );
}
